import { convertCase, numberToFormatted, validateCountWithHypen, validateTextWithHypen, } from '@/utils';
import { hubMainReportTableHeader } from '@/constants/hubAdjustment';
import { getGlobalStore } from '@/lib/global-store';
import { i18n } from '@/locales';
export default class HubAdjustment {
    _salesB2BOrderCompletedCount;
    _salesB2BDeliveryCharge;
    _salesB2BDeliveryChargeTax;
    _salesB2BDeliveryTotalCharge;
    _salesHeadOfficeContractStoreOrderCompletedCount;
    _salesHeadOfficeContractStoreDeliveryCharge;
    _salesHeadOfficeContractStoreDeliveryChargeTax;
    _salesHeadOfficeContractStoreDeliveryTotalCharge;
    _salesOrderDistributorHubFeeOrderCompletedCount;
    _salesOrderDistributorHubFee;
    _salesOrderDistributorHubFeeTax;
    _salesOrderDistributorHubTotalFee;
    _salesAdjustmentFeePayback;
    _salesAdjustmentFeeTaxPayback;
    _salesAdjustmentTotalFeePayback;
    _salesHeadOfficeContractStoreManagementFee;
    _salesHeadOfficeContractStoreManagementFeeTax;
    _salesHeadOfficeContractStoreManagementTotalFee;
    _salesHeadOfficeContractStoreFee;
    _salesHeadOfficeContractStoreFeeTax;
    _salesHeadOfficeContractStoreTotalFee;
    _correctedCost;
    _correctedTax;
    _correctedTotalCost;
    _correctedReason;
    _purchaseHubFeeOrderCompletedCount;
    _purchaseHubFee;
    _purchaseHubFeeTax;
    _purchaseHubTotalFee;
    _purchaseStoreManagementFee;
    _purchaseStoreManagementTotalFee;
    _purchaseStoreManagementFeeTax;
    // 사업자번호 상태
    _businessStatus;
    // 과세유형
    _taxType;
    // 세금계산서Id
    _taxInvoiceId;
    isRepresentativeHub;
    constructor({ 
    // [매출 - 배달대행료 - B2B]
    salesB2BOrderCompletedCount, salesB2BDeliveryCharge, salesB2BDeliveryChargeTax, salesB2BDeliveryTotalCharge, 
    // [매출 - 배달대행료 - 로드샵(본사계약)]
    salesHeadOfficeContractStoreOrderCompletedCount, salesHeadOfficeContractStoreDeliveryCharge, salesHeadOfficeContractStoreDeliveryChargeTax, salesHeadOfficeContractStoreDeliveryTotalCharge, 
    // [매출 - 허브 수수료 발주 총판 - 로드샵(본사계약)]
    salesOrderDistributorHubFeeOrderCompletedCount, salesOrderDistributorHubFee, salesOrderDistributorHubFeeTax, salesOrderDistributorHubTotalFee, 
    // [매출 - 기타 수수료]
    salesAdjustmentFeePayback, salesAdjustmentFeeTaxPayback, salesAdjustmentTotalFeePayback, 
    // [매출 - 상점 관리비 - 로드샵(본사계약)]
    salesHeadOfficeContractStoreManagementFee, salesHeadOfficeContractStoreManagementFeeTax, salesHeadOfficeContractStoreManagementTotalFee, 
    // [매출 - 상점 수수료 - 로드샵(본사계약)]
    salesHeadOfficeContractStoreFee, salesHeadOfficeContractStoreFeeTax, salesHeadOfficeContractStoreTotalFee, 
    // [매출 - 보정 처리]
    correctedCost, correctedTax, correctedTotalCost, 
    // 보정 처리 사유 툴팁 메세지
    correctedReason, 
    // [매입 - 허브 수수료 - 로드샵(일반)]
    purchaseHubFeeOrderCompletedCount, purchaseHubFee, purchaseHubFeeTax, purchaseHubTotalFee, 
    // [매입 - 상점 관리비 - 로드샵(일반)]
    purchaseStoreManagementFee, purchaseStoreManagementFeeTax, purchaseStoreManagementTotalFee, 
    // 사업자번호 상태
    businessStatus, 
    // 과세유형
    taxType, 
    // 세금계산서Id
    taxInvoiceId, }) {
        this._salesB2BOrderCompletedCount = salesB2BOrderCompletedCount;
        this._salesB2BDeliveryCharge = salesB2BDeliveryCharge;
        this._salesB2BDeliveryChargeTax = salesB2BDeliveryChargeTax;
        this._salesB2BDeliveryTotalCharge = salesB2BDeliveryTotalCharge;
        this._salesHeadOfficeContractStoreOrderCompletedCount = salesHeadOfficeContractStoreOrderCompletedCount;
        this._salesHeadOfficeContractStoreDeliveryCharge = salesHeadOfficeContractStoreDeliveryCharge;
        this._salesHeadOfficeContractStoreDeliveryChargeTax = salesHeadOfficeContractStoreDeliveryChargeTax;
        this._salesHeadOfficeContractStoreDeliveryTotalCharge = salesHeadOfficeContractStoreDeliveryTotalCharge;
        /* eslint-disable max-len */
        this._salesOrderDistributorHubFeeOrderCompletedCount = salesOrderDistributorHubFeeOrderCompletedCount;
        this._salesOrderDistributorHubFee = salesOrderDistributorHubFee;
        this._salesOrderDistributorHubFeeTax = salesOrderDistributorHubFeeTax;
        this._salesOrderDistributorHubTotalFee = salesOrderDistributorHubTotalFee;
        this._salesAdjustmentFeePayback = salesAdjustmentFeePayback;
        this._salesAdjustmentFeeTaxPayback = salesAdjustmentFeeTaxPayback;
        this._salesAdjustmentTotalFeePayback = salesAdjustmentTotalFeePayback;
        this._salesHeadOfficeContractStoreManagementFee = salesHeadOfficeContractStoreManagementFee;
        this._salesHeadOfficeContractStoreManagementFeeTax = salesHeadOfficeContractStoreManagementFeeTax;
        this._salesHeadOfficeContractStoreManagementTotalFee = salesHeadOfficeContractStoreManagementTotalFee;
        this._salesHeadOfficeContractStoreFee = salesHeadOfficeContractStoreFee;
        this._salesHeadOfficeContractStoreFeeTax = salesHeadOfficeContractStoreFeeTax;
        this._salesHeadOfficeContractStoreTotalFee = salesHeadOfficeContractStoreTotalFee;
        this._correctedCost = correctedCost;
        this._correctedTax = correctedTax;
        this._correctedTotalCost = correctedTotalCost;
        this._correctedReason = correctedReason;
        this._purchaseHubFeeOrderCompletedCount = purchaseHubFeeOrderCompletedCount;
        this._purchaseHubFee = purchaseHubFee;
        this._purchaseHubFeeTax = purchaseHubFeeTax;
        this._purchaseHubTotalFee = purchaseHubTotalFee;
        this._purchaseStoreManagementFee = purchaseStoreManagementFee;
        this._purchaseStoreManagementFeeTax = purchaseStoreManagementFeeTax;
        this._purchaseStoreManagementTotalFee = purchaseStoreManagementTotalFee;
        this._businessStatus = businessStatus;
        this._taxType = taxType;
        this._taxInvoiceId = taxInvoiceId;
        const vuexStore = getGlobalStore();
        this.isRepresentativeHub = vuexStore.getters['hubSelector/getterIsRepresentativeHub'];
    }
    get formattedSalesB2BOrderCompletedCount() {
        return validateCountWithHypen(numberToFormatted(this._salesB2BOrderCompletedCount));
    }
    get formattedSalesB2BDeliveryCharge() {
        return validateTextWithHypen(numberToFormatted(this._salesB2BDeliveryCharge, {
            style: 'currency',
        }));
    }
    get formattedSalesB2BDeliveryChargeTax() {
        return validateTextWithHypen(numberToFormatted(this._salesB2BDeliveryChargeTax, {
            style: 'currency',
        }));
    }
    get formattedSalesB2BDeliveryTotalCharge() {
        return validateTextWithHypen(numberToFormatted(this._salesB2BDeliveryTotalCharge, {
            style: 'currency',
        }));
    }
    get formattedSalesHeadOfficeContractStoreOrderCompletedCount() {
        return validateCountWithHypen(numberToFormatted(this._salesHeadOfficeContractStoreOrderCompletedCount));
    }
    get formattedSalesHeadOfficeContractStoreDeliveryCharge() {
        return validateTextWithHypen(numberToFormatted(this._salesHeadOfficeContractStoreDeliveryCharge, {
            style: 'currency',
        }));
    }
    get formattedSalesHeadOfficeContractStoreDeliveryChargeTax() {
        return validateTextWithHypen(numberToFormatted(this._salesHeadOfficeContractStoreDeliveryChargeTax, {
            style: 'currency',
        }));
    }
    get formattedSalesHeadOfficeContractStoreDeliveryTotalCharge() {
        return validateTextWithHypen(numberToFormatted(this._salesHeadOfficeContractStoreDeliveryTotalCharge, {
            style: 'currency',
        }));
    }
    get formattedSalesOrderDistributorHubFeeOrderCompletedCount() {
        return validateCountWithHypen(numberToFormatted(this._salesOrderDistributorHubFeeOrderCompletedCount));
    }
    get formattedSalesOrderDistributorHubFee() {
        return validateTextWithHypen(numberToFormatted(this._salesOrderDistributorHubFee, {
            style: 'currency',
        }));
    }
    get formattedSalesOrderDistributorHubFeeTax() {
        return validateTextWithHypen(numberToFormatted(this._salesOrderDistributorHubFeeTax, {
            style: 'currency',
        }));
    }
    get formattedSalesOrderDistributorHubTotalFee() {
        return validateTextWithHypen(numberToFormatted(this._salesOrderDistributorHubTotalFee, {
            style: 'currency',
        }));
    }
    get formattedSalesAdjustmentFeePayback() {
        return validateTextWithHypen(numberToFormatted(this._salesAdjustmentFeePayback, {
            style: 'currency',
        }));
    }
    get formattedSalesAdjustmentFeeTaxPayback() {
        return validateTextWithHypen(numberToFormatted(this._salesAdjustmentFeeTaxPayback, {
            style: 'currency',
        }));
    }
    get formattedSalesAdjustmentTotalFeePayback() {
        return validateTextWithHypen(numberToFormatted(this._salesAdjustmentTotalFeePayback, {
            style: 'currency',
        }));
    }
    get formattedSalesHeadOfficeContractStoreManagementFee() {
        return validateTextWithHypen(numberToFormatted(this._salesHeadOfficeContractStoreManagementFee, {
            style: 'currency',
        }));
    }
    get formattedSalesHeadOfficeContractStoreManagementFeeTax() {
        return validateTextWithHypen(numberToFormatted(this._salesHeadOfficeContractStoreManagementFeeTax, {
            style: 'currency',
        }));
    }
    get formattedSalesHeadOfficeContractStoreManagementTotalFee() {
        return validateTextWithHypen(numberToFormatted(this._salesHeadOfficeContractStoreManagementTotalFee, {
            style: 'currency',
        }));
    }
    get formattedSalesHeadOfficeContractStoreFee() {
        return validateTextWithHypen(numberToFormatted(this._salesHeadOfficeContractStoreFee, {
            style: 'currency',
        }));
    }
    get formattedSalesHeadOfficeContractStoreFeeTax() {
        return validateTextWithHypen(numberToFormatted(this._salesHeadOfficeContractStoreFeeTax, {
            style: 'currency',
        }));
    }
    get formattedSalesHeadOfficeContractStoreTotalFee() {
        return validateTextWithHypen(numberToFormatted(this._salesHeadOfficeContractStoreTotalFee, {
            style: 'currency',
        }));
    }
    get formattedCorrectedCost() {
        return validateTextWithHypen(numberToFormatted(this._correctedCost, {
            style: 'currency',
        }));
    }
    get formattedCorrectedTax() {
        return validateTextWithHypen(numberToFormatted(this._correctedTax, {
            style: 'currency',
        }));
    }
    get formattedCorrectedTotalCost() {
        return validateTextWithHypen(numberToFormatted(this._correctedTotalCost, {
            style: 'currency',
        }));
    }
    get formattedCorrectedReason() {
        return this._correctedReason;
    }
    get isSomeSalesOrderDistributorHubFeeAmountExist() {
        return this._salesOrderDistributorHubFeeOrderCompletedCount !== 0
            || this._salesOrderDistributorHubFee !== 0
            || this._salesOrderDistributorHubFeeTax !== 0
            || this._salesOrderDistributorHubTotalFee !== 0;
    }
    get salesItemsTotalCount() {
        let salesItemsTotalCount = this._salesB2BOrderCompletedCount
            + this._salesHeadOfficeContractStoreOrderCompletedCount;
        if (this.isRepresentativeHub || this.isSomeSalesOrderDistributorHubFeeAmountExist) {
            salesItemsTotalCount += this
                ._salesOrderDistributorHubFeeOrderCompletedCount;
        }
        if (!salesItemsTotalCount) {
            return 0;
        }
        return salesItemsTotalCount;
    }
    get formattedSalesItemsTotalCount() {
        return validateCountWithHypen(numberToFormatted(this.salesItemsTotalCount));
    }
    get salesItemsTotalFee() {
        let salesItemsTotalFee = this._salesB2BDeliveryCharge
            + this._salesHeadOfficeContractStoreDeliveryCharge
            + this._salesAdjustmentFeePayback
            + this._salesHeadOfficeContractStoreManagementFee
            + this._salesHeadOfficeContractStoreFee
            + this._correctedCost;
        if (this.isRepresentativeHub || this.isSomeSalesOrderDistributorHubFeeAmountExist) {
            salesItemsTotalFee += this
                ._salesOrderDistributorHubFee;
        }
        if (!salesItemsTotalFee) {
            return 0;
        }
        return salesItemsTotalFee;
    }
    get formattedSalesItemsTotalFee() {
        return validateTextWithHypen(numberToFormatted(this.salesItemsTotalFee, {
            style: 'currency',
        }));
    }
    get salesItemsTotalFeeTax() {
        let salesItemsTotalFeeTax = this._salesB2BDeliveryChargeTax
            + this._salesHeadOfficeContractStoreDeliveryChargeTax
            + this._salesAdjustmentFeeTaxPayback
            + this._salesHeadOfficeContractStoreManagementFeeTax
            + this._salesHeadOfficeContractStoreFeeTax
            + this._correctedTax;
        if (this.isRepresentativeHub || this.isSomeSalesOrderDistributorHubFeeAmountExist) {
            salesItemsTotalFeeTax += this
                ._salesOrderDistributorHubFeeTax;
        }
        if (!salesItemsTotalFeeTax) {
            return 0;
        }
        return salesItemsTotalFeeTax;
    }
    get formattedSalesItemsTotalFeeTax() {
        return validateTextWithHypen(numberToFormatted(this.salesItemsTotalFeeTax, {
            style: 'currency',
        }));
    }
    get salesItemsTotalSum() {
        let salesItemsTotalSum = this._salesB2BDeliveryTotalCharge
            + this._salesHeadOfficeContractStoreDeliveryTotalCharge
            + this._salesAdjustmentTotalFeePayback
            + this._salesHeadOfficeContractStoreManagementTotalFee
            + this._salesHeadOfficeContractStoreTotalFee
            + this._correctedTotalCost;
        if (this.isRepresentativeHub || this.isSomeSalesOrderDistributorHubFeeAmountExist) {
            salesItemsTotalSum += this
                ._salesOrderDistributorHubTotalFee;
        }
        if (!salesItemsTotalSum) {
            return 0;
        }
        return salesItemsTotalSum;
    }
    get formattedSalesItemsTotalSum() {
        return validateTextWithHypen(numberToFormatted(this.salesItemsTotalSum, {
            style: 'currency',
        }));
    }
    get formattedPurchaseHubFeeOrderCompletedCount() {
        return validateCountWithHypen(numberToFormatted(this._purchaseHubFeeOrderCompletedCount));
    }
    get formattedPurchaseHubFee() {
        return validateTextWithHypen(numberToFormatted(this._purchaseHubFee, {
            style: 'currency',
        }));
    }
    get formattedPurchaseHubFeeTax() {
        return validateTextWithHypen(numberToFormatted(this._purchaseHubFeeTax, {
            style: 'currency',
        }));
    }
    get formattedPurchaseHubTotalFee() {
        return validateTextWithHypen(numberToFormatted(this._purchaseHubTotalFee, {
            style: 'currency',
        }));
    }
    get formattedPurchaseStoreManagementFee() {
        return validateTextWithHypen(numberToFormatted(this._purchaseStoreManagementFee, {
            style: 'currency',
        }));
    }
    get formattedPurchaseStoreManagementTotalFee() {
        return validateTextWithHypen(numberToFormatted(this._purchaseStoreManagementTotalFee, {
            style: 'currency',
        }));
    }
    get formattedPurchaseStoreManagementFeeTax() {
        return validateTextWithHypen(numberToFormatted(this._purchaseStoreManagementFeeTax, {
            style: 'currency',
        }));
    }
    get purchaseItemsTotalCount() {
        return this._purchaseHubFeeOrderCompletedCount;
    }
    get formattedPurchaseItemsTotalCount() {
        return validateCountWithHypen(numberToFormatted(this.purchaseItemsTotalCount));
    }
    get purchaseItemsTotalFee() {
        const purchaseItemsTotalFee = this._purchaseHubFee + this._purchaseStoreManagementFee;
        if (!purchaseItemsTotalFee) {
            return 0;
        }
        return purchaseItemsTotalFee;
    }
    get formattedPurchaseItemsTotalFee() {
        return validateTextWithHypen(numberToFormatted(this.purchaseItemsTotalFee, {
            style: 'currency',
        }));
    }
    get purchaseItemsTotalFeeTax() {
        const purchaseItemsTotalFeeTax = this._purchaseHubFeeTax + this._purchaseStoreManagementFeeTax;
        if (!purchaseItemsTotalFeeTax) {
            return 0;
        }
        return purchaseItemsTotalFeeTax;
    }
    get formattedPurchaseItemsTotalFeeTax() {
        return validateTextWithHypen(numberToFormatted(this.purchaseItemsTotalFeeTax, {
            style: 'currency',
        }));
    }
    get purchaseItemsTotalSum() {
        const purchaseItemsTotalSum = this._purchaseHubTotalFee + this._purchaseStoreManagementTotalFee;
        if (!purchaseItemsTotalSum) {
            return 0;
        }
        return purchaseItemsTotalSum;
    }
    get formattedPurchaseItemsTotalSum() {
        return validateTextWithHypen(numberToFormatted(this.purchaseItemsTotalSum, {
            style: 'currency',
        }));
    }
    get isAllSalesB2BDeliveryChargeAmountExist() {
        return [
            this._salesB2BOrderCompletedCount,
            this._salesB2BDeliveryCharge,
            this._salesB2BDeliveryChargeTax,
            this._salesB2BDeliveryTotalCharge,
        ].some((amount) => amount !== 0);
    }
    get isAllSalesHeadOfficeContractStoreDeliveryChargeAmountExist() {
        return [
            this._salesHeadOfficeContractStoreOrderCompletedCount,
            this._salesHeadOfficeContractStoreDeliveryCharge,
            this._salesHeadOfficeContractStoreDeliveryChargeTax,
            this._salesHeadOfficeContractStoreDeliveryTotalCharge,
        ].some((amount) => amount !== 0);
    }
    get isAllSalesOrderDistributorHubFeeAmountExist() {
        return [
            this._salesOrderDistributorHubFeeOrderCompletedCount,
            this._salesOrderDistributorHubFee,
            this._salesOrderDistributorHubFeeTax,
            this._salesOrderDistributorHubTotalFee,
        ].some((amount) => amount !== 0);
    }
    get isAllSalesHeadOfficeContractStoreManagementFeeAmountExist() {
        return [
            this._salesHeadOfficeContractStoreManagementFee,
            this._salesHeadOfficeContractStoreManagementFeeTax,
            this._salesHeadOfficeContractStoreManagementTotalFee,
        ].some((amount) => amount !== 0);
    }
    get isAllSalesHeadOfficeContractStoreFeeAmountExist() {
        return [
            this._salesHeadOfficeContractStoreFee,
            this._salesHeadOfficeContractStoreFeeTax,
            this._salesHeadOfficeContractStoreTotalFee,
        ].some((amount) => amount !== 0);
    }
    get isAllPurchaseHubFeeAmountExist() {
        return [
            this._purchaseHubFeeOrderCompletedCount,
            this._purchaseHubFee,
            this._purchaseHubFeeTax,
            this._purchaseHubTotalFee,
        ].some((amount) => amount !== 0);
    }
    get isAllPurchaseStoreManagementAmountExist() {
        return [
            this._purchaseStoreManagementFee,
            this._purchaseStoreManagementTotalFee,
            this._purchaseStoreManagementFeeTax,
        ].some((amount) => amount !== 0);
    }
    /** 사업자등록번호 유효성 결과 */
    get formattedBusinessStatusType() {
        const bussinessStatus = convertCase(this._businessStatus, 'enum', 'snake');
        const bussinessStatusText = i18n.t(`views.hub_adjustment.business_status_option.${bussinessStatus}`);
        return validateTextWithHypen(bussinessStatusText);
    }
    /** 과세유형 */
    get formattedTaxType() {
        const taxType = convertCase(this._taxType, 'enum', 'snake');
        const taxTypeText = i18n.t(`views.hub_adjustment.tax_type_option.${taxType}`);
        return validateTextWithHypen(taxTypeText);
    }
    /** 세금계산서 Id */
    get taxInvoiceId() {
        return this._taxInvoiceId;
    }
    getCsvHeaderAndData() {
        const tableHeader = hubMainReportTableHeader.map((item) => item.text);
        const emptyCell = '';
        const salesData = [
            [
                '배달대행료 (B2B)',
                // [매출 - 배달대행료 - B2B]
                this._salesB2BOrderCompletedCount?.toString(),
                this._salesB2BDeliveryCharge?.toString(),
                this._salesB2BDeliveryChargeTax?.toString(),
                this._salesB2BDeliveryTotalCharge?.toString(),
            ],
            [
                '배달대행료 (로드샵 - 본사계약)',
                // [매출 - 배달대행료 - 로드샵(본사계약)]
                this._salesHeadOfficeContractStoreOrderCompletedCount?.toString(),
                this._salesHeadOfficeContractStoreDeliveryCharge?.toString(),
                this._salesHeadOfficeContractStoreDeliveryChargeTax?.toString(),
                this._salesHeadOfficeContractStoreDeliveryTotalCharge?.toString(),
            ],
            [
                '허브 수수료 발주 총판 수익',
                // [매출 - 허브 수수료 발주 총판 - 로드샵(본사계약)]
                this._salesOrderDistributorHubFeeOrderCompletedCount?.toString(),
                this._salesOrderDistributorHubFee?.toString(),
                this._salesOrderDistributorHubFeeTax?.toString(),
                this._salesOrderDistributorHubTotalFee?.toString(),
            ],
            [
                '기타 수수료',
                emptyCell,
                this._salesAdjustmentFeePayback?.toString(),
                this._salesAdjustmentFeeTaxPayback?.toString(),
                this._salesAdjustmentTotalFeePayback?.toString(),
            ],
            [
                '상점 관리비 (로드샵 - 본사계약)',
                // [매출 - 상점 관리비 - 로드샵(본사계약)]
                emptyCell,
                this._salesHeadOfficeContractStoreManagementFee?.toString(),
                this._salesHeadOfficeContractStoreManagementFeeTax?.toString(),
                this._salesHeadOfficeContractStoreManagementTotalFee?.toString(),
            ],
            [
                '상점 수수료 (로드샵 - 본사계약)',
                // [매출 - 상점 수수료 - 로드샵(본사계약)]
                emptyCell,
                this._salesHeadOfficeContractStoreFee?.toString(),
                this._salesHeadOfficeContractStoreFeeTax?.toString(),
                this._salesHeadOfficeContractStoreTotalFee?.toString(),
            ],
            [
                '보정 처리',
                // [보정 처리]
                emptyCell,
                this._correctedCost?.toString(),
                this._correctedTax?.toString(),
                this._correctedTotalCost?.toString(),
            ],
            [
                '총',
                this.salesItemsTotalCount?.toString(),
                this.salesItemsTotalFee?.toString(),
                this.salesItemsTotalFeeTax?.toString(),
                this.salesItemsTotalSum?.toString(),
            ],
        ];
        const purchaseData = [
            [
                '허브 수수료 (로드샵 - 일반)',
                // [매입 - 허브 수수료 - 로드샵(일반)]
                this._purchaseHubFeeOrderCompletedCount?.toString(),
                this._purchaseHubFee?.toString(),
                this._purchaseHubFeeTax?.toString(),
                this._purchaseHubTotalFee?.toString(),
            ],
            [
                '상점 관리비 (로드샵 - 일반)',
                // [매입 - 상점 관리비 - 로드샵(일반)]
                emptyCell,
                this._purchaseStoreManagementFee?.toString(),
                this._purchaseStoreManagementFeeTax?.toString(),
                this._purchaseStoreManagementTotalFee?.toString(),
            ],
            [
                '총',
                this.purchaseItemsTotalCount?.toString(),
                this.purchaseItemsTotalFee?.toString(),
                this.purchaseItemsTotalFeeTax?.toString(),
                this.purchaseItemsTotalSum?.toString(),
            ],
        ];
        const header = [
            ...tableHeader,
            emptyCell,
            ...tableHeader,
        ];
        // [매출 - 허브 수수료 발주 총판 - 로드샵(본사계약)] 노출조건
        // 대표허브가 선택되었을 때 또는 [매출 - 허브 수수료 발주 총판 - 로드샵(본사계약)]관련 값이 있을 때
        const isOrderDistributorHubFeeRowExist = this.isRepresentativeHub || this.isSomeSalesOrderDistributorHubFeeAmountExist;
        if (!isOrderDistributorHubFeeRowExist) {
            salesData.splice(2, 1);
        }
        const data = salesData.map((row, idx) => {
            if (purchaseData[idx]) {
                return row.concat([
                    emptyCell,
                    ...purchaseData[idx],
                ]);
            }
            return row;
        });
        return {
            header,
            data,
        };
    }
}
